import styled from "styled-components";

export const Wrapper = styled.div`
    grid-area: service;
    display: flex;
    justify-self: right;
`;
